__turbopack_context__.v({
  "card": "attest-module__Nh8jXW__card",
  "cardBody": "attest-module__Nh8jXW__cardBody",
  "cardChips": "attest-module__Nh8jXW__cardChips",
  "cardDetails": "attest-module__Nh8jXW__cardDetails",
  "cardHeading": "attest-module__Nh8jXW__cardHeading",
  "cardLabel": "attest-module__Nh8jXW__cardLabel",
  "cardName": "attest-module__Nh8jXW__cardName",
  "cardRow": "attest-module__Nh8jXW__cardRow",
  "cardStatus": "attest-module__Nh8jXW__cardStatus",
  "counter": "attest-module__Nh8jXW__counter",
  "deck": "attest-module__Nh8jXW__deck",
  "demo": "attest-module__Nh8jXW__demo",
  "demoCertificate": "attest-module__Nh8jXW__demoCertificate",
  "demoFlow": "attest-module__Nh8jXW__demoFlow",
  "demoPeople": "attest-module__Nh8jXW__demoPeople",
  "demoPortrait": "attest-module__Nh8jXW__demoPortrait",
  "demoSteps": "attest-module__Nh8jXW__demoSteps",
  "drawButton": "attest-module__Nh8jXW__drawButton",
  "hero": "attest-module__Nh8jXW__hero",
  "heroChips": "attest-module__Nh8jXW__heroChips",
  "heroCopy": "attest-module__Nh8jXW__heroCopy",
  "heroGrid": "attest-module__Nh8jXW__heroGrid",
  "heroVisual": "attest-module__Nh8jXW__heroVisual",
  "kicker": "attest-module__Nh8jXW__kicker",
  "notice": "attest-module__Nh8jXW__notice",
  "page": "attest-module__Nh8jXW__page",
  "photo": "attest-module__Nh8jXW__photo",
  "process": "attest-module__Nh8jXW__process",
  "promise": "attest-module__Nh8jXW__promise",
  "proof": "attest-module__Nh8jXW__proof",
  "proofCopy": "attest-module__Nh8jXW__proofCopy",
  "proofGrid": "attest-module__Nh8jXW__proofGrid",
  "rowIcon": "attest-module__Nh8jXW__rowIcon",
  "step": "attest-module__Nh8jXW__step",
  "stepIcon": "attest-module__Nh8jXW__stepIcon",
  "stepNumber": "attest-module__Nh8jXW__stepNumber",
  "steps": "attest-module__Nh8jXW__steps",
  "wrap": "attest-module__Nh8jXW__wrap",
});
